/** Shared with the loading skeleton so the two can't drift apart. */
export const TEMPLATES_SECTION_SX = { mt: 8, width: "100%" } as const;

export const TEMPLATE_GRID_SX = {
  display: "grid",
  gridTemplateColumns: {
    xs: "repeat(2, minmax(0, 1fr))",
    sm: "repeat(3, minmax(0, 1fr))",
    md: "repeat(5, minmax(0, 1fr))",
    lg: "repeat(6, minmax(0, 1fr))",
  },
  gap: { xs: 1, sm: 1.5 },
} as const;
